import React, { FC, useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useLocation } from "react-router-dom";
import getParams from "../../hooks/useParams";
import axios from "axios";
import createDownloadLink from "../../util/createDownloadLink";

const StyledDiv = styled("div")({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  width: "100%",
  justifyContent: "space-around",
  alignItems: "center",
  marginTop: 100,
  paddingTop: 20,
  paddingBottom: 20,
});

const StyledTypography = styled(Typography)({
  fontWeight: "bold",
  padding: 20,
  paddingBottom: 40,
});

async function getInstallData(quoteId: string) {
  if (!quoteId) return;
  return await axios.post(
    `/api/install`,
    { quoteId },
    { responseType: "blob" }
  );
}

const ShippingLabel: FC = () => {
  const location = useLocation();
  const quoteId = getParams(location.pathname);

  const [load, setLoad] = useState(false);

  useEffect(() => {
    (async function () {
      if (load) return;
      setLoad(true);
      try {
        const res = await getInstallData(quoteId);
        createDownloadLink(res?.data, "details.pdf");
      } catch (err) {
        console.log(err);
      } finally {
        setLoad(false);
      }
    })();
  }, []);

  if (load) {
    return (
      <StyledDiv>
        <StyledTypography>Generating...</StyledTypography>
      </StyledDiv>
    );
  }

  return null;
};

export default ShippingLabel;
